var exports = {
  "AM": "Popover__UteXdk",
  "__": "Popover_Content__GyeZ-L",
  "DZ": "Heading__sV7Gon",
  "Yi": "BranchName__FGKGkh",
};

module.exports = exports;
